<div class="z-fx-sc" [ngClass]="size === 'small' ? 'z-fx-gap-4' : 'z-fx-gap-8'">
  <figure class="survey-status" [ngClass]="[status, size]"></figure>

  <span [ngClass]="size === 'big' ? 'zef-text-h2' : size === 'medium' ? 'zef-text-h3' : 'zef-text-p2'">
    <ng-content></ng-content>
  </span>
</div>
